import { render } from "./headerDevis.vue?vue&type=template&id=5e53cf84&scoped=true"
import script from "./headerDevis.vue?vue&type=script&lang=js"
export * from "./headerDevis.vue?vue&type=script&lang=js"

import "./headerDevis.vue?vue&type=style&index=0&id=5e53cf84&lang=scss&scoped=true"

import exportComponent from "/usr/src/test-oho-sales/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e53cf84"]])

export default __exports__